// Frontend time utilities with safe env access for Vite/CRA
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(tz);

// Try multiple env styles (Vite / CRA); fallback to IST
let ENV_TZ =
  (typeof process !== 'undefined' &&
    process.env &&
    (process.env.REACT_APP_APP_TZ || process.env.REACT_APP_TZ)) ||
  'Asia/Kolkata';

export const LOCAL_TZ = ENV_TZ;
// Allow override via Vite/CRA env
let ENV_FMT = 'DD MMM YYYY, hh:mm A';
try {
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.APP_DATE_FMT) {
    ENV_FMT = import.meta.env.APP_DATE_FMT;
  } else if (typeof process !== 'undefined' && process.env && process.env.APP_DATE_FMT) {
    ENV_FMT = process.env.APP_DATE_FMT;
  }
} catch (_) {}

export const DATE_FMT = ENV_FMT;

export function fmtDate(dt, fmt = DATE_FMT) {
  if (!dt) return '-';
  const d = dayjs(dt);
  if (!d.isValid()) return '-';
  return d.tz(LOCAL_TZ).format(fmt);
}
